import bean from 'bean';
import $ from '~/qwery';
bean.setSelectorEngine($);
export default bean;



// WEBPACK FOOTER //
// ./makosh/assets/bean.js